import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import { SIDEBAR_MENU_ITEMS } from "@/layouts/constants";
import { SidebarItem } from "@/layouts/types";

interface useRedirectArgs {
  sidebarItems: SidebarItem[];
  shouldRedirectOnMount?: boolean;
}

function findFirstLink(sidebarItems: SidebarItem[]): string {
  if (!sidebarItems.length) return "";
  const firstItem = sidebarItems[0];
  if (firstItem.link) return firstItem.link;
  return findFirstLink(firstItem.subItems || []);
}

export function useRedirect({ sidebarItems, shouldRedirectOnMount = true }: useRedirectArgs) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const isMainSidebarPath = SIDEBAR_MENU_ITEMS.find((item) => item.link === pathname);
    if (!isMainSidebarPath || !shouldRedirectOnMount) return;
    const firstLink = findFirstLink(sidebarItems);
    if (firstLink) {
      navigate(firstLink);
    }
  }, [navigate, pathname, sidebarItems, shouldRedirectOnMount]);
}
